import { render, staticRenderFns } from "./browse.vue?vue&type=template&id=4b5ed996"
import script from "./browse.vue?vue&type=script&lang=js"
export * from "./browse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports